export default __webpack_public_path__ + "static/bentoSectionImg3-156b20d344f029e07a97132dd3d0dcac.webp";